import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.startsWith("#") ? hash.substring(1) : hash);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      toast.error("Missing session_id");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("atlas_token", data.token);
        localStorage.setItem("atlas_user", JSON.stringify(data.user));
        toast.success(`Welcome, ${data.user.full_name.split(" ")[0]}!`);
        // Take entrepreneurs directly into Business DNA™ onboarding on their first visit
        let dest = "/app";
        if (data.user.role === "entrepreneur") {
          try {
            const dna = await api.get("/dna");
            const done = (dna.data?.dna?.completed_sections || []).length;
            dest = done >= 11 ? "/app" : "/app/onboarding";
          } catch { dest = "/app/onboarding"; }
        }
        window.history.replaceState(null, "", dest);
        window.location.href = dest;
      } catch (err) {
        toast.error(err.response?.data?.detail || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-50">
      <div className="text-center">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-slate-950" />
        <div className="mt-4 label-mono">Signing you in with Google…</div>
      </div>
    </div>
  );
}
